// International Constants and Configuration

// Common countries list (ISO 3166-1 alpha-3 codes) - sorted alphabetically
export const COUNTRIES = [
  { value: 'ARE', label: 'United Arab Emirates', code: 'AE' },
  { value: 'ARG', label: 'Argentina', code: 'AR' },
  { value: 'AUS', label: 'Australia', code: 'AU' },
  { value: 'AUT', label: 'Austria', code: 'AT' },
  { value: 'BEL', label: 'Belgium', code: 'BE' },
  { value: 'BGR', label: 'Bulgaria', code: 'BG' },
  { value: 'BRA', label: 'Brazil', code: 'BR' },
  { value: 'CAN', label: 'Canada', code: 'CA' },
  { value: 'NAM', label: 'Namibia', code: 'NA' },
  { value: 'CHE', label: 'Switzerland', code: 'CH' },
  { value: 'CHL', label: 'Chile', code: 'CL' },
  { value: 'CHN', label: 'China', code: 'CN' },
  { value: 'COL', label: 'Colombia', code: 'CO' },
  { value: 'CYP', label: 'Cyprus', code: 'CY' },
  { value: 'CZE', label: 'Czech Republic', code: 'CZ' },
  { value: 'DEU', label: 'Germany', code: 'DE' },
  { value: 'DNK', label: 'Denmark', code: 'DK' },
  { value: 'EGY', label: 'Egypt', code: 'EG' },
  { value: 'ESP', label: 'Spain', code: 'ES' },
  { value: 'EST', label: 'Estonia', code: 'EE' },
  { value: 'ETH', label: 'Ethiopia', code: 'ET' },
  { value: 'FIN', label: 'Finland', code: 'FI' },
  { value: 'FRA', label: 'France', code: 'FR' },
  { value: 'GBR', label: 'United Kingdom', code: 'GB' },
  { value: 'GHA', label: 'Ghana', code: 'GH' },
  { value: 'GRC', label: 'Greece', code: 'GR' },
  { value: 'HKG', label: 'Hong Kong', code: 'HK' },
  { value: 'HRV', label: 'Croatia', code: 'HR' },
  { value: 'HUN', label: 'Hungary', code: 'HU' },
  { value: 'IDN', label: 'Indonesia', code: 'ID' },
  { value: 'IND', label: 'India', code: 'IN' },
  { value: 'IRL', label: 'Ireland', code: 'IE' },
  { value: 'ISL', label: 'Iceland', code: 'IS' },
  { value: 'ISR', label: 'Israel', code: 'IL' },
  { value: 'ITA', label: 'Italy', code: 'IT' },
  { value: 'JPN', label: 'Japan', code: 'JP' },
  { value: 'KEN', label: 'Kenya', code: 'KE' },
  { value: 'KOR', label: 'South Korea', code: 'KR' },
  { value: 'LTU', label: 'Lithuania', code: 'LT' },
  { value: 'LUX', label: 'Luxembourg', code: 'LU' },
  { value: 'LVA', label: 'Latvia', code: 'LV' },
  { value: 'MAR', label: 'Morocco', code: 'MA' },
  { value: 'MEX', label: 'Mexico', code: 'MX' },
  { value: 'MLT', label: 'Malta', code: 'MT' },
  { value: 'MYS', label: 'Malaysia', code: 'MY' },
  { value: 'NGA', label: 'Nigeria', code: 'NG' },
  { value: 'NLD', label: 'Netherlands', code: 'NL' },
  { value: 'NOR', label: 'Norway', code: 'NO' },
  { value: 'NZL', label: 'New Zealand', code: 'NZ' },
  { value: 'PER', label: 'Peru', code: 'PE' },
  { value: 'PHL', label: 'Philippines', code: 'PH' },
  { value: 'POL', label: 'Poland', code: 'PL' },
  { value: 'PRT', label: 'Portugal', code: 'PT' },
  { value: 'ROU', label: 'Romania', code: 'RO' },
  { value: 'RUS', label: 'Russia', code: 'RU' },
  { value: 'SAU', label: 'Saudi Arabia', code: 'SA' },
  { value: 'SGP', label: 'Singapore', code: 'SG' },
  { value: 'SRB', label: 'Serbia', code: 'RS' },
  { value: 'SVK', label: 'Slovakia', code: 'SK' },
  { value: 'SVN', label: 'Slovenia', code: 'SI' },
  { value: 'SWE', label: 'Sweden', code: 'SE' },
  { value: 'THA', label: 'Thailand', code: 'TH' },
  { value: 'TUN', label: 'Tunisia', code: 'TN' },
  { value: 'TUR', label: 'Turkey', code: 'TR' },
  { value: 'TWN', label: 'Taiwan', code: 'TW' },
  { value: 'TZA', label: 'Tanzania', code: 'TZ' },
  { value: 'UGA', label: 'Uganda', code: 'UG' },
  { value: 'UKR', label: 'Ukraine', code: 'UA' },
  { value: 'USA', label: 'United States', code: 'US' },
  { value: 'VNM', label: 'Vietnam', code: 'VN' },
  { value: 'ZAF', label: 'South Africa', code: 'ZA' }
];

// Currency configuration - Default to USD
export const CURRENCY = {
  code: 'USD',
  symbol: '$',
  name: 'US Dollar'
};

// Supported currencies
export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'ZAR', symbol: 'R', name: 'South African Rand' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'CHF', symbol: 'Fr', name: 'Swiss Franc' },
  { code: 'NAD', symbol: 'N$', name: 'Namibian Dollar' }
];

// Phone number format: International format (flexible)
// Accepts: +[country code][number] or international format
export const PHONE_REGEX = /^(\+?[1-9]\d{1,14})$/;

// Postal code format: Flexible (alphanumeric, 3-10 characters)
// Different countries have different formats, so we accept a wide range
export const POSTAL_CODE_REGEX = /^[A-Za-z0-9\s-]{3,10}$/;

// Weight units: kg (metric)
export const WEIGHT_UNIT = 'kg';

// Dimension units: cm (metric)
export const DIMENSION_UNIT = 'cm';

// State/Province field label (varies by country)
export const getStateProvinceLabel = (countryCode) => {
  const labels = {
    'USA': 'State',
    'CAN': 'Province',
    'AUS': 'State',
    'GBR': 'County/Region',
    'ZAF': 'Province',
    'IND': 'State',
    'DEU': 'State',
    'FRA': 'Region',
    'ITA': 'Region',
    'ESP': 'Province',
    'MEX': 'State',
    'BRA': 'State',
    'NAM': 'Region'
  };
  return labels[countryCode] || 'State/Province';
};

// States/Provinces/Regions by Country
export const STATES_BY_COUNTRY = {
  'USA': [
    { value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' }, { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' }, { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' }, { value: 'DE', label: 'Delaware' }, { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' }, { value: 'HI', label: 'Hawaii' }, { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' }, { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' }, { value: 'KY', label: 'Kentucky' }, { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' }, { value: 'MD', label: 'Maryland' }, { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' }, { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' }, { value: 'MT', label: 'Montana' }, { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' }, { value: 'NH', label: 'New Hampshire' }, { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' }, { value: 'NY', label: 'New York' }, { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' }, { value: 'OH', label: 'Ohio' }, { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' }, { value: 'PA', label: 'Pennsylvania' }, { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' }, { value: 'SD', label: 'South Dakota' }, { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' }, { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' }, { value: 'WA', label: 'Washington' }, { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' }, { value: 'WY', label: 'Wyoming' }, { value: 'DC', label: 'District of Columbia' }
  ],
  'GBR': [
    { value: 'ENG', label: 'England' }, { value: 'SCT', label: 'Scotland' }, { value: 'WLS', label: 'Wales' },
    { value: 'NIR', label: 'Northern Ireland' },
    // Major counties/regions in England
    { value: 'LND', label: 'London' }, { value: 'YOR', label: 'Yorkshire' }, { value: 'LAN', label: 'Lancashire' },
    { value: 'ESS', label: 'Essex' }, { value: 'KEN', label: 'Kent' }, { value: 'HAM', label: 'Hampshire' },
    { value: 'SUR', label: 'Surrey' }, { value: 'DEV', label: 'Devon' }, { value: 'SOM', label: 'Somerset' },
    { value: 'NOR', label: 'Norfolk' }, { value: 'SUF', label: 'Suffolk' }, { value: 'OXF', label: 'Oxfordshire' }
  ],
  'CAN': [
    { value: 'AB', label: 'Alberta' }, { value: 'BC', label: 'British Columbia' }, { value: 'MB', label: 'Manitoba' },
    { value: 'NB', label: 'New Brunswick' }, { value: 'NL', label: 'Newfoundland and Labrador' },
    { value: 'NS', label: 'Nova Scotia' }, { value: 'NT', label: 'Northwest Territories' },
    { value: 'NU', label: 'Nunavut' }, { value: 'ON', label: 'Ontario' }, { value: 'PE', label: 'Prince Edward Island' },
    { value: 'QC', label: 'Quebec' }, { value: 'SK', label: 'Saskatchewan' }, { value: 'YT', label: 'Yukon' }
  ],
  'AUS': [
    { value: 'NSW', label: 'New South Wales' }, { value: 'VIC', label: 'Victoria' }, { value: 'QLD', label: 'Queensland' },
    { value: 'WA', label: 'Western Australia' }, { value: 'SA', label: 'South Australia' },
    { value: 'TAS', label: 'Tasmania' }, { value: 'ACT', label: 'Australian Capital Territory' },
    { value: 'NT', label: 'Northern Territory' }
  ],
  'DEU': [
    { value: 'BW', label: 'Baden-Württemberg' }, { value: 'BY', label: 'Bavaria' }, { value: 'BE', label: 'Berlin' },
    { value: 'BB', label: 'Brandenburg' }, { value: 'HB', label: 'Bremen' }, { value: 'HH', label: 'Hamburg' },
    { value: 'HE', label: 'Hesse' }, { value: 'MV', label: 'Mecklenburg-Vorpommern' },
    { value: 'NI', label: 'Lower Saxony' }, { value: 'NW', label: 'North Rhine-Westphalia' },
    { value: 'RP', label: 'Rhineland-Palatinate' }, { value: 'SL', label: 'Saarland' },
    { value: 'SN', label: 'Saxony' }, { value: 'ST', label: 'Saxony-Anhalt' },
    { value: 'SH', label: 'Schleswig-Holstein' }, { value: 'TH', label: 'Thuringia' }
  ],
  'FRA': [
    { value: 'ARA', label: 'Auvergne-Rhône-Alpes' }, { value: 'BFC', label: 'Bourgogne-Franche-Comté' },
    { value: 'BRE', label: 'Brittany' }, { value: 'CVL', label: 'Centre-Val de Loire' },
    { value: 'COR', label: 'Corsica' }, { value: 'GES', label: 'Grand Est' },
    { value: 'HDF', label: 'Hauts-de-France' }, { value: 'IDF', label: 'Île-de-France' },
    { value: 'NOR', label: 'Normandy' }, { value: 'NAQ', label: 'Nouvelle-Aquitaine' },
    { value: 'OCC', label: 'Occitanie' }, { value: 'PDL', label: 'Pays de la Loire' },
    { value: 'PAC', label: "Provence-Alpes-Côte d'Azur" }
  ],
  'ITA': [
    { value: 'ABR', label: 'Abruzzo' }, { value: 'BAS', label: 'Basilicata' }, { value: 'CAL', label: 'Calabria' },
    { value: 'CAM', label: 'Campania' }, { value: 'EMR', label: 'Emilia-Romagna' }, { value: 'FVG', label: 'Friuli-Venezia Giulia' },
    { value: 'LAZ', label: 'Lazio' }, { value: 'LIG', label: 'Liguria' }, { value: 'LOM', label: 'Lombardy' },
    { value: 'MAR', label: 'Marche' }, { value: 'MOL', label: 'Molise' }, { value: 'PIE', label: 'Piedmont' },
    { value: 'PUG', label: 'Apulia' }, { value: 'SAR', label: 'Sardinia' }, { value: 'SIC', label: 'Sicily' },
    { value: 'TOS', label: 'Tuscany' }, { value: 'TAA', label: 'Trentino-Alto Adige' },
    { value: 'UMB', label: 'Umbria' }, { value: 'VAE', label: 'Aosta Valley' }, { value: 'VEN', label: 'Veneto' }
  ],
  'ESP': [
    { value: 'AND', label: 'Andalusia' }, { value: 'ARA', label: 'Aragon' }, { value: 'AST', label: 'Asturias' },
    { value: 'BAL', label: 'Balearic Islands' }, { value: 'CAN', label: 'Canary Islands' },
    { value: 'CAB', label: 'Cantabria' }, { value: 'CAS', label: 'Castile and León' },
    { value: 'CLM', label: 'Castile-La Mancha' }, { value: 'CAT', label: 'Catalonia' },
    { value: 'EXT', label: 'Extremadura' }, { value: 'GAL', label: 'Galicia' },
    { value: 'MAD', label: 'Madrid' }, { value: 'MUR', label: 'Murcia' },
    { value: 'NAV', label: 'Navarre' }, { value: 'PV', label: 'Basque Country' },
    { value: 'RIO', label: 'La Rioja' }, { value: 'VAL', label: 'Valencia' }
  ],
  'IND': [
    { value: 'AP', label: 'Andhra Pradesh' }, { value: 'AR', label: 'Arunachal Pradesh' }, { value: 'AS', label: 'Assam' },
    { value: 'BR', label: 'Bihar' }, { value: 'CT', label: 'Chhattisgarh' }, { value: 'GA', label: 'Goa' },
    { value: 'GJ', label: 'Gujarat' }, { value: 'HR', label: 'Haryana' }, { value: 'HP', label: 'Himachal Pradesh' },
    { value: 'JK', label: 'Jammu and Kashmir' }, { value: 'JH', label: 'Jharkhand' }, { value: 'KA', label: 'Karnataka' },
    { value: 'KL', label: 'Kerala' }, { value: 'MP', label: 'Madhya Pradesh' }, { value: 'MH', label: 'Maharashtra' },
    { value: 'MN', label: 'Manipur' }, { value: 'ML', label: 'Meghalaya' }, { value: 'MZ', label: 'Mizoram' },
    { value: 'NL', label: 'Nagaland' }, { value: 'OR', label: 'Odisha' }, { value: 'PB', label: 'Punjab' },
    { value: 'RJ', label: 'Rajasthan' }, { value: 'SK', label: 'Sikkim' }, { value: 'TN', label: 'Tamil Nadu' },
    { value: 'TG', label: 'Telangana' }, { value: 'TR', label: 'Tripura' }, { value: 'UP', label: 'Uttar Pradesh' },
    { value: 'UT', label: 'Uttarakhand' }, { value: 'WB', label: 'West Bengal' }
  ],
  'MEX': [
    { value: 'AGU', label: 'Aguascalientes' }, { value: 'BCN', label: 'Baja California' },
    { value: 'BCS', label: 'Baja California Sur' }, { value: 'CAM', label: 'Campeche' },
    { value: 'CHP', label: 'Chiapas' }, { value: 'CHH', label: 'Chihuahua' },
    { value: 'COA', label: 'Coahuila' }, { value: 'COL', label: 'Colima' },
    { value: 'DIF', label: 'Mexico City' }, { value: 'DUR', label: 'Durango' },
    { value: 'GUA', label: 'Guanajuato' }, { value: 'GRO', label: 'Guerrero' },
    { value: 'HID', label: 'Hidalgo' }, { value: 'JAL', label: 'Jalisco' },
    { value: 'MEX', label: 'Mexico' }, { value: 'MIC', label: 'Michoacán' },
    { value: 'MOR', label: 'Morelos' }, { value: 'NAY', label: 'Nayarit' },
    { value: 'NLE', label: 'Nuevo León' }, { value: 'OAX', label: 'Oaxaca' },
    { value: 'PUE', label: 'Puebla' }, { value: 'QUE', label: 'Querétaro' },
    { value: 'ROO', label: 'Quintana Roo' }, { value: 'SLP', label: 'San Luis Potosí' },
    { value: 'SIN', label: 'Sinaloa' }, { value: 'SON', label: 'Sonora' },
    { value: 'TAB', label: 'Tabasco' }, { value: 'TAM', label: 'Tamaulipas' },
    { value: 'TLA', label: 'Tlaxcala' }, { value: 'VER', label: 'Veracruz' },
    { value: 'YUC', label: 'Yucatán' }, { value: 'ZAC', label: 'Zacatecas' }
  ],
  'BRA': [
    { value: 'AC', label: 'Acre' }, { value: 'AL', label: 'Alagoas' }, { value: 'AP', label: 'Amapá' },
    { value: 'AM', label: 'Amazonas' }, { value: 'BA', label: 'Bahia' }, { value: 'CE', label: 'Ceará' },
    { value: 'DF', label: 'Distrito Federal' }, { value: 'ES', label: 'Espírito Santo' },
    { value: 'GO', label: 'Goiás' }, { value: 'MA', label: 'Maranhão' },
    { value: 'MT', label: 'Mato Grosso' }, { value: 'MS', label: 'Mato Grosso do Sul' },
    { value: 'MG', label: 'Minas Gerais' }, { value: 'PA', label: 'Pará' },
    { value: 'PB', label: 'Paraíba' }, { value: 'PR', label: 'Paraná' },
    { value: 'PE', label: 'Pernambuco' }, { value: 'PI', label: 'Piauí' },
    { value: 'RJ', label: 'Rio de Janeiro' }, { value: 'RN', label: 'Rio Grande do Norte' },
    { value: 'RS', label: 'Rio Grande do Sul' }, { value: 'RO', label: 'Rondônia' },
    { value: 'RR', label: 'Roraima' }, { value: 'SC', label: 'Santa Catarina' },
    { value: 'SP', label: 'São Paulo' }, { value: 'SE', label: 'Sergipe' },
    { value: 'TO', label: 'Tocantins' }
  ],
  'ZAF': [
    { value: 'EC', label: 'Eastern Cape' },
    { value: 'FS', label: 'Free State' },
    { value: 'GP', label: 'Gauteng' },
    { value: 'KZN', label: 'KwaZulu-Natal' },
    { value: 'LP', label: 'Limpopo' },
    { value: 'MP', label: 'Mpumalanga' },
    { value: 'NC', label: 'Northern Cape' },
    { value: 'NW', label: 'North West' },
    { value: 'WC', label: 'Western Cape' }
  ],
  'NAM': [
    { value: 'ER', label: 'Erongo' }, { value: 'HA', label: 'Hardap' }, { value: 'KA', label: 'Karas' },
    { value: 'KE', label: 'Kavango East' }, { value: 'KW', label: 'Kavango West' }, { value: 'KH', label: 'Khomas' },
    { value: 'KU', label: 'Kunene' }, { value: 'OW', label: 'Ohangwena' }, { value: 'OS', label: 'Omaheke' },
    { value: 'ON', label: 'Oshana' }, { value: 'OT', label: 'Oshikoto' }, { value: 'OU', label: 'Otjozondjupa' }
  ]
};

// Get states/provinces for a country
export const getStatesForCountry = (countryCode) => {
  return STATES_BY_COUNTRY[countryCode] || null;
};

// Check if country has predefined states/provinces
export const hasPredefinedStates = (countryCode) => {
  return countryCode in STATES_BY_COUNTRY;
};

// Common dropoff locations (international)
export const DROPOFF_LOCATIONS = [
  { value: 'nyc', label: 'New York, USA', address: '123 Broadway, New York, NY 10001, USA' },
  { value: 'lax', label: 'Los Angeles, USA', address: '456 Main St, Los Angeles, CA 90001, USA' },
  { value: 'lon', label: 'London, UK', address: '789 High Street, London, SW1A 1AA, United Kingdom' },
  { value: 'tor', label: 'Toronto, Canada', address: '321 Queen St, Toronto, ON M5H 2M9, Canada' },
  { value: 'syd', label: 'Sydney, Australia', address: '654 George St, Sydney NSW 2000, Australia' },
  { value: 'dub', label: 'Dubai, UAE', address: 'Sheikh Zayed Road, Dubai, United Arab Emirates' },
  { value: 'sin', label: 'Singapore', address: 'Orchard Road, Singapore 238801' },
  { value: 'hkg', label: 'Hong Kong', address: 'Central, Hong Kong' },
  { value: 'tok', label: 'Tokyo, Japan', address: '1-1-1 Shibuya, Shibuya City, Tokyo 150-0002, Japan' },
  { value: 'fra', label: 'Frankfurt, Germany', address: 'Mainzer Landstraße 123, 60327 Frankfurt, Germany' }
];

